export const toClamp = (max, min = `${max * 0.5}`) =>
  `clamp(${min}px, ${(max * 100) / 1920}vw, ${max}px)`;

export const mediaScreen = (content, maxScreen, minScreen) =>
  `@media only screen and (max-width: ${maxScreen}px) ${
    minScreen ? `and (min-width: ${minScreen}px)` : ''
  }{${content}}`;
